<template>
  <v-chip :color="state.color" dark small class="elevation-1">
    <v-icon left small>
      {{ state.icon }}
    </v-icon>
    {{ state.name }}
  </v-chip>
</template>

<script>
export default {
  name: "StateChip",
  props: {
    state: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
};
</script>
